
<template>
  <span  :class="`uppercase rounded-md px-1.5 py-[0.065rem] text-[0.55rem]  font-semibold ${computedClasses}`">
    <slot></slot>
  </span>
</template>

<script setup>
import { computed } from "vue"

const props = defineProps({
  color: {
    type: String,
    default: "default",
  },
})

const colors = {
  successOutline: "bg-transparent text-success border-success border",
  errorOutline: "bg-transparent text-error border-error border",
  infoOutline: "bg-transparent text-info border-info border",
  success: "bg-success text-emerald-900",
  error: "bg-error text-rose-900",
  red: "bg-rose-10 text-rose-600",
  green: "bg-emerald-100 text-emerald-600",
  blue: "bg-sky-200 text-sky-600",
  gray: "bg-zinc-100 text-zinc-600",
  orange: "bg-amber-100 text-amber-600",
  info: "bg-sky-100 text-sky-600",
  primary: "bg-primary text-white dark:text-primary-content",
  default: "bg-primary text-white dark:text-primary-content",
}

const computedClasses = computed(() => {
  return colors[props.color] || colors.default
})

</script>

<style scoped>

</style>
